import { AxiosError } from "axios";

export class ApiInterceptorError extends Error {
  handledByInterceptor = false;
  sourceError: AxiosError | Error | null | unknown = null;

  constructor(
    handledByInterceptor: boolean,
    sourceError: AxiosError | Error | null | unknown,
    message?: string,
    options?: ErrorOptions,
  ) {
    super(message, options);

    if ("captureStackTrace" in Error) {
      if (typeof Error.captureStackTrace === "function") {
        Error.captureStackTrace(this, ApiInterceptorError);
      }
    }

    this.name = "ApiInterceptorError";
    this.handledByInterceptor = handledByInterceptor;
    this.sourceError = sourceError;
  }
}
